import { Button, Grid } from "@mui/material";
import PageHeaderLayout from "../../../components/Layout/PageHeaderLayout";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { createContext, useState } from "react";
import Swal from "sweetalert2";
import { EventServices } from "./EventServices";
import EventList from "./EventList";
import AddEditEvent from "./AddEditEvent";

const EventContext = createContext();

export default function Events(){
    const navigate = useNavigate();
    const eventInitialData = {
        title:'',
        image:'',
        description:'',
    }
    const [eventData,setEventData]= useState(eventInitialData);
    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
        filters: {
            searchKey: "",
            sortBy:'createdAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [eventList, setEventList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchEventList = async () => {
        try {
          setLoadingList(true)
          const listResponse = await EventServices.allEvents({
            page: paginationModel.page,
            limit: paginationModel.pageSize,
            filters: {
              searchKey: paginationModel.filters.searchKey,   // Use the title filter from the paginationModel
              sortBy: paginationModel.filters.sortBy,
              sortType: paginationModel.filters.sortType,
              filterOptions: paginationModel.filters.filterOptions || []
            }
          });
          console.log("Service list Response:",listResponse)
        //   setValue('status', paginationModel.filters.status)
          if (listResponse.success == '1') {
            setEventList(listResponse.data.events);
            setTotalRowCount(listResponse.data.totalItems);
          }
          else {
            //   Swal.fire('Request failed','','error')
          }
        } catch (error) {
          Swal.fire(error.message, '', 'error')
        }
        setLoadingList(false)
    };

    const [selectedEventData, setSelectedEventData] = useState(null);

    return (
        <EventContext.Provider value={{ eventInitialData,eventData,setEventData,fetchEventList,eventList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedEventData, setSelectedEventData}}>        
            <Grid container spacing={1}>            
                <Grid item xs={12} lg={5}>
                    <AddEditEvent/>
                </Grid>
                {/* <PermissionGuard feature="event" permission="canView"> */}
                    <Grid item xs={12} lg={7}>
                        <EventList/>
                    </Grid>
                {/* </PermissionGuard> */}
            </Grid>
        </EventContext.Provider>
    )
}

export { EventContext }